import React from "react"

export function VerticalDots(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="4"
      height="16"
      viewBox="0 0 4 16"
      fill="none"
      {...props}
    >
      <path
        d="M1.96875 11.25C1.44661 11.25 0.945846 11.4574 0.576634 11.8266C0.207421 12.1958 0 12.6966 0 13.2188C0 13.7409 0.207421 14.2417 0.576634 14.6109C0.945846 14.9801 1.44661 15.1875 1.96875 15.1875C2.4909 15.1875 2.99165 14.9801 3.36087 14.6109C3.73008 14.2417 3.9375 13.7409 3.9375 13.2188C3.9375 12.6966 3.73008 12.1958 3.36087 11.8266C2.99165 11.4574 2.4909 11.25 1.96875 11.25ZM1.96875 5.625C1.44661 5.625 0.945846 5.83242 0.576634 6.20163C0.207421 6.57085 0 7.07161 0 7.59375C0 8.1159 0.207421 8.61665 0.576634 8.98587C0.945846 9.35508 1.44661 9.5625 1.96875 9.5625C2.4909 9.5625 2.99165 9.35508 3.36087 8.98587C3.73008 8.61665 3.9375 8.1159 3.9375 7.59375C3.9375 7.07161 3.73008 6.57085 3.36087 6.20163C2.99165 5.83242 2.4909 5.625 1.96875 5.625ZM3.9375 1.96875C3.9375 1.44661 3.73008 0.945846 3.36087 0.576634C2.99165 0.207421 2.4909 0 1.96875 0C1.44661 0 0.945846 0.207421 0.576634 0.576634C0.207421 0.945846 0 1.44661 0 1.96875C0 2.4909 0.207421 2.99165 0.576634 3.36087C0.945846 3.73008 1.44661 3.9375 1.96875 3.9375C2.4909 3.9375 2.99165 3.73008 3.36087 3.36087C3.73008 2.99165 3.9375 2.4909 3.9375 1.96875Z"
        fill="currentColor"
      />
    </svg>
  )
}
